import React from 'react';
import { Redirect } from 'react-router-dom';
import data from '../../data/data21.json';

const FoundationIntro: React.FC = () => {
    const first = (data as any[])[0];
    if (first) {
        return <Redirect to={`/article/21/${first.id}`} />;
    }
    return null;
};

export default FoundationIntro;